import type { RequestConnectorInvocationResult } from '@/adapters/apiv1.g';
import type { InvokeConnectorFeatureResult } from '@/types/core/connector';

/**
 * Transform invocation command result from API shape to UI domain shape.
 */
export function extractInvocationResult(
  model: RequestConnectorInvocationResult
): InvokeConnectorFeatureResult {
  const seq = model.run_sequence;
  return {
    connectorId: model.connector_id ?? '',
    featureId: model.feature_id ?? '',
    runSequence: seq === undefined || seq === null ? '' : String(seq),
    tenantId: model.tenant_id ?? '',
  };
}
